import cookies from 'js-cookie'

export const getAbTests = () => {
  return cookies.get('TestAB_Groups') || ''
}

export const isChatVI = () => cookies.get('CHAT_VI') === '1'
export const removeChatVI = () => removeCookie('CHAT_VI')

/**
 * Removes a given cookie from the user's browser
 * @param {string} name
 */

export const removeCookie = name => {
  cookies.remove(name, { domain: '.olx.com.br' })
}

export const getExperimentVariant = (experiment) => {
  try {
    return (getAbTests()).split(experiment + '_')[1].split('.')[0]
  } catch (err) {
    return ''
  }
}
